module.exports = __webpack_public_path__ + "static/media/play.6d916a7a.png";